// @ts-nocheck
import React, { useEffect, useState, startTransition } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Clear";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { FetchProfileList } from "../../redux/slice/PurchaseProfileList";
import {
  Typography,
  Paper,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Checkbox,
  Button,
  ListItem,
  ListItemIcon,
  ListItemText,
  InputAdornment,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Dialog,
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {
  AddproxyBid,
  cancelProxyBid,
  getProxyBidId,
  handleUpdateProxyBid,
} from "../../services/Api";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../services/AuthContext";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedProfileForAuction } from "../../redux/slice/selectedProfileSlice";

export default function RightSidebar({
  isOpen,
  toggleSidebar,
  auctionId,
  activeStep,
  setActiveStep,
  completed,
  setCompleted,
  openingBid,
  reservePrice,
}) {
  const {
    investorId: { investorId, username },
  } = useAuth();
  // const [completed, setCompleted] = useState({ 0: true, 1: false });
  const [selectedProfile, setSelectedProfile] = useState(investorId);
  const [expanded, setExpanded] = useState([true, false]);
  const [proxyBidPrice, setProxyBidPrice] = useState(0);
  const [isBidProtectionEnable, setIsBidProtectionEnable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [PlaceBidText, setPlaceBidText] = useState("Place Bid");
  const [errors, setErrors] = useState("");
  const [boxOpen, setBoxOpen] = useState(false);
  const [oldProxybid, setOldProxyBid] = useState(null);
  const [reservePriceCheck, setReservePriceCheck] = useState("");
  // const [updateProxyBid, setUpdateProxyBid] = useState(true)
  const { userData } = useSelector((state) => state.user);
  console.log(userData, 'userdata')
  const selectedProfiles = useSelector(
    (state) => state.selectedProfile[auctionId]
  );

  const profileList = useSelector((state) => state?.purchaseProfile?.profiles?.body);
  console.log("profileList", profileList)
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let proxybidData = {};
  const inputRef = React.useRef();

  useEffect(() => {
    const fetchProxyBidValue = async () => {
      setLoading(true);
      try {
        const response = await getProxyBidId(investorId, auctionId);
        if (response.data) {
          setProxyBidPrice(formatToDollar(response.data.preauctionBidAmount));
          setSelectedProfile(response.data.purchaseProfileId);
          setIsBidProtectionEnable(response.data.bidProtectionEnabled);
          setActiveStep(0);
          setCompleted({ 0: true, 1: true });
          setPlaceBidText("Update Bid");
          setOldProxyBid(formatToDollar(response.data.preauctionBidAmount));
        }
      } catch (error) {
        console.error(error);
        setErrors(error);
      } finally {
        setLoading(false);
      }
    };
    if (isOpen) {
      fetchProxyBidValue();
    } else {
      resetForm();
    }

    return () => {
      resetForm();
    };
  }, [isOpen]);
  const getErrorMessage = (error) => {
    if (!error) return null;
    if (typeof error === "string") return error;
    if (typeof error === "object" && error.message) return error.message;
    return "An unexpected error occurred.";
  };
  useEffect(() => {
    if (profileList && profileList.length > 0) {
      const defaultProfile = profileList.find((profile) => profile.isDefault);
      if (defaultProfile) {
        setSelectedProfile(defaultProfile.investorId);
      }
    }
  }, [profileList]);

  const handlePurchaseProfile = (InvestorId, UserType, ProfileName) => {
    const profile = { InvestorId, UserType, ProfileName };
    dispatch(setSelectedProfileForAuction({ auctionId, profile }));
  };

  useEffect(() => {
    dispatch(FetchProfileList(investorId));
  }, [isOpen])

  const handleRadioChange = (event) => {
    setSelectedProfile(parseInt(event.target.value));
    setCompleted((prev) => ({ ...prev, 0: true }));
    setExpanded((prev) => {
      const newExpanded = [...prev];
      newExpanded[1] = true;
      return newExpanded;
    });
    setActiveStep(1);
  };
  const steps = [
    {
      label: "Select a purchase profile",
    },
    {
      label: "Enter your Proxy Bid",
    },
  ];

  const handleSubmit = async (event) => {
    // Validation for purchase profile
    if (selectedProfile === "") {
      setErrors("Please select a purchase profile.");
      return;
    }

    // Validation for proxy bid price

    // First, ensure proxyBidPrice is a string that can be parsed
    let parsedProxyBidPrice = parseInt(proxyBidPrice?.replace(/,/g, ""), 10);

    // Check if the parsed value is a valid number
    if (
      (isNaN(parsedProxyBidPrice) || parsedProxyBidPrice < reservePrice) &&
      parsedProxyBidPrice % 1000 !== 0
    ) {
      setErrors(
        parsedProxyBidPrice < openingBid && parsedProxyBidPrice % 1000 !== 0
          ? `Proxy bid must be in multiples of ${parsedProxyBidPrice} and must be above the Reserve Price ${openingBid}`
          : "Please enter a valid proxy bid amount."
      );

      // Clear the error message after 3 seconds
      setTimeout(() => {
        setErrors("");
      }, 5000);
      return;
    }
    // Create the payload
    proxybidData = {
      investorId: investorId,
      auctionId,
      purchaseProfileId: selectedProfiles?.InvestorId || selectedProfile,
      proxyBidPrice: parseInt(proxyBidPrice.replace(/,/g, ""), 10),
      isBidProtectionEnable,
      bidderId: `${investorId}`,
    };

    if (!openingBid) {
      if (proxyBidPrice < 1000) {
        setMessage("Proxy bid amount must be at least $1000");
      }
    }

    try {
      setLoading(true);
      const response = await AddproxyBid(proxybidData);
      // Log the full response for debugging

      // Handle success
      if (response && response.statusCode === 200) {
        toast.success(response.message, {
          className: 'custom-toast'
        });

        resetForm();
        toggleSidebar(false, event);
        navigate("/home", { state: { auctionId } });
        setLoading(false);

      } else {
        setErrors("Failed to place proxy bid. Please try again.");
      }
    } catch (error) {
      if (error.response.data) {
        if (error.response.data.statusCode === 400 && error.response.data.message.includes("balance is insufficient")) {
          console.error(error)
          setReservePriceCheck(<p className="font-medium">
            Funds insufficient to place bids! <Link to="/managefunds" style={{ color: "#FF5C39", fontWeight: 500, textDecoration: "underline" }}>Add Funds</Link> to participate in the auction.
          </p>)
        } else {
          setErrors(error.response.data.message);
        }
      }
      setLoading(false);
      setTimeout(() => {
        setErrors("");
      }, 5000);
    } finally {

    }
  };

  const resetForm = () => {
    setIsBidProtectionEnable(false);
    setProxyBidPrice(0);
    setActiveStep(0);
    setCompleted({ 0: true, 1: false });
    setExpanded([true, false]);
    setMessage("");
    setErrors("");
    setPlaceBidText("Place Bid");
    setOldProxyBid(null);
    setReservePriceCheck("")
    // setUpdateProxyBid(true)
  };

  function formatToDollar(amount) {
    return new Intl.NumberFormat("en-US", {
      style: "decimal",
      // currency: "USD",
      minimumFractionDigits: 0, // No decimal places
      maximumFractionDigits: 0,
    }).format(amount);
  }

  const handlePriceChange = (event) => {
    const input = event.target;
    const rawValue = input.value.replace(/[^0-9]/g, "");
    const selectionStart = input.selectionStart;

    // Count digits before the cursor in the old value
    let digitsBeforeCursor = 0;
    for (let i = 0; i < selectionStart; i++) {
      if (/\d/.test(input.value[i])) digitsBeforeCursor++;
    }

    if (rawValue === "") {
      setProxyBidPrice("");
      setCompleted((prev) => ({ ...prev, 1: false }));
      setReservePriceCheck("");
      return;
    }

    const numericValue = parseInt(rawValue, 10);

    if (!isNaN(numericValue)) {
      const formattedAmount = formatToDollar(numericValue);

      // Find the new cursor position: after the same number of digits
      let newCursor = 0, digitCount = 0;
      while (newCursor < formattedAmount.length && digitCount < digitsBeforeCursor) {
        if (/\d/.test(formattedAmount[newCursor])) digitCount++;
        newCursor++;
      }

      // If we're at the end of the input and adding a digit, stay at the end
      if (selectionStart === input.value.length && digitsBeforeCursor === rawValue.length - 1) {
        newCursor = formattedAmount.length;
      }

      if (numericValue < reservePrice || numericValue % 1000 !== 0) {
        const message = reservePrice > 0
          ? `Proxy bid must be in multiples of $1,000 and above $${formatToDollar(reservePrice)}.`
          : `Proxy bid must be in multiples of $1,000`;
        setReservePriceCheck(message);
        setCompleted((prev) => ({ ...prev, 1: false }));
        setProxyBidPrice(formattedAmount);
      } else {
        setProxyBidPrice(formattedAmount);
        setCompleted((prev) => ({ ...prev, 1: true }));
        setReservePriceCheck("");
      }

      setTimeout(() => {
        // Access the actual input element inside the TextField
        const inputElement = inputRef.current?.querySelector('input') || input;
        if (inputElement) {
          inputElement.setSelectionRange(newCursor, newCursor);
        }
      }, 0);
    } else {
      setErrors("Please enter a valid number.");
      setCompleted((prev) => ({ ...prev, 1: false })); // Mark as incomplete
    }
  };
  const handleclose = (event) => {
    resetForm();
    toggleSidebar(false, event);
  };

  const handleCancelProxyBid = async () => {
    try {
      setLoading(true);
      const response = await cancelProxyBid(investorId, auctionId);

      // Check for successful response based on the responseMessage
      if (response && response.responseMessage) {
        handleboxClose();
        toast.success(response.responseMessage, {
          className: 'custom-toast'
        }); // Use the responseMessage for user feedback
        resetForm();
      } else {
        setErrors(response.data.message);
      }
    } catch (error) {
      if (error.response.data) {
        setErrors(error.response.data.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const OnUpdateProxyBid = async (event) => {
    const proxybidData = {
      investorId: investorId,
      auctionId,
      purchaseProfileId: selectedProfile,
      proxyBidPrice: parseInt(proxyBidPrice.replace(/,/g, ""), 10),
      isBidProtectionEnable,
      bidderId: `${investorId}`,
    };
    try {
      if (investorId && auctionId) {
        // Check if the new proxy bid is the same as the old one
        if (proxyBidPrice === oldProxybid) {
          setErrors("Please update the proxy bid amount.");
          setTimeout(() => {
            setErrors("");
          }, 2000);
          return; // Return early to prevent API call
        }
        setLoading(true);
        const { response } = await handleUpdateProxyBid(
          investorId,
          auctionId,
          proxybidData
        );
        toast.success(response.message, {
          className: 'custom-toast'
        });

        resetForm();
        toggleSidebar(false, event);
        navigate("/home", { state: { auctionId } });
        setLoading(false)

      }
    } catch (error) {
      setLoading(false)
      if (error.response.data) {
        if (error.response.data.statusCode === 400 && error.response.data.message.includes("balance is insufficient")) {
          console.error(error)
          setReservePriceCheck(<p className="font-medium">
            Funds insufficient to place bids! <Link to="/managefunds" style={{ color: "#FF5C39", fontWeight: 500, textDecoration: "underline" }}>Add Funds</Link> to participate in the auction.
          </p>)
        } else {
          setErrors(error.response.data.message);
        }
      }
    } finally {
    }
  };

  const isboxOpen = () => {
    setBoxOpen(true);
  };

  const handleboxClose = () => {
    setBoxOpen(false);
  };

  const handleCombinedChange = (event, account) => {
    handleRadioChange(event);
    console.log(account, "accounting");
    handlePurchaseProfile(account?.investorId, account?.userType, account?.profileName.length > 1 ? account?.profileName : account?.firstName);
  };

  const manageSelfProfile = {
    InvestorId: investorId,
    ProfileName: userData?.profileName?.length > 1 ? userData?.profileName : userData?.firstName + ' ' + userData?.lastName,
    UserType: userData?.userType,
    accountStatus: userData?.accountStatus,
    lastVerifiedOn: userData?.lastVerifiedOn,
    isDefault: userData?.isDefault,
  };

  const handleNavigate = () => {
    startTransition(() => {
      navigate("/purchaseprofile/identity-verification");
    });
  };

  const list = (anchor) => (
    <Box
      sx={{
        width: {
          xs: "100%", // For extra-small screens (mobile)
          sm: 400, // For small screens (tablets)
          md: 500, // For medium screens (desktops)
          lg: 650,
        },
        padding: 2,
        backgroundColor: "#F8F8F8",
      }}
      role="presentation"
    >
      <List>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography
            sx={{ fontWeight: 600, fontSize: "22px", lineHeight: "39px" }}
          >
            Place Your Bid
          </Typography>
          <div>
            {oldProxybid && (
              <span
                onClick={isboxOpen}
                id="cancel-proxy-bid"
                className="text-[#FF5C39] underline text-[12px] font-medium mr-1 cursor-pointer"
              >
                Cancel Proxy Bid
              </span>
            )}
            <Dialog
              open={boxOpen}
              onClose={handleboxClose}
              fullWidth
              maxWidth="sm"
              sx={{
                "& .MuiDialog-paper": {
                  padding: { xs: 2, sm: 3 },
                },
              }}
            >
              <Box
                sx={{
                  padding: 3,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <ErrorOutlineIcon
                  sx={{
                    fontSize: { xs: "24px", sm: "28px" },
                    color: "#FF5C39",
                  }}
                />
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: { xs: "16px", sm: "20px" },
                    lineHeight: "30px",
                    textAlign: "center",
                  }}
                >
                  Are you sure you want to cancel your proxy bid?
                </Typography>
                <div
                  className="flex-row mt-5"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Button
                    onClick={handleboxClose}
                    variant="outlined"
                    size="medium"
                    sx={{
                      borderColor: "#FF5C39",
                      textTransform: "none",
                      borderRadius: "8px",
                      width: "20%",
                      marginRight: { xs: 1, sm: 2 },
                      color: "#FF5C39",
                      backgroundColor: "transparent",
                      px: 0,
                    }}
                  >
                    No
                  </Button>
                  <Button
                    variant="contained"
                    size="medium"
                    sx={{
                      backgroundColor: "#FF5C39",
                      textTransform: "none",
                      width: "20%",
                      color: "white",
                      borderRadius: "8px",
                    }}
                    onClick={handleCancelProxyBid}
                  >
                    Yes
                  </Button>
                </div>
              </Box>
            </Dialog>
            <IconButton
              onClick={handleclose}
              sx={{
                "&:focus": {
                  outline: "none",
                },
                "&:focusVisible": {
                  outline: "none",
                },
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <CloseIcon
                sx={{
                  fontSize: { xs: "24px", sm: "28px" },
                  color: "#3B3B3B",
                }}
              />
            </IconButton>
          </div>
        </Box>
        <Divider sx={{ my: 1 }} /> {/* Adjusted spacing around the Divider */}
        {/* Proxy Bid Card Start*/}
        <Box
          mt={2}
          sx={{ backgroundColor: "white", boxShadow: 3, borderRadius: 1, p: 2 }}
        >
          <Stepper
            activeStep={activeStep}
            orientation="vertical"
            nonLinear={true}
          >
            {steps.map((step, index) => (
              <Step
                key={step.label}
                completed={completed[index]}
                expanded={true}
                sx={{
                  marginLeft: ".5px",
                }}
              >
                <StepLabel
                  StepIconProps={{
                    sx: {
                      "&.Mui-completed": {
                        color: "green",
                      },
                    },
                  }}
                >
                  <Box display="flex" alignItems="center">
                    <Typography
                      fontWeight={500}
                      className="text-[18px] text-[#3B3B3B] pl-5 leading-[27px]"
                    >
                      {step.label}
                    </Typography>
                  </Box>
                </StepLabel>
                <StepContent>
                  <Box sx={{ ml: 2, mt: 1 }}>
                    {index === 0 && (
                      <Paper variant="outlined" sx={{ pt: 1, px: 2 }}>
                        {/* <div className="border-b-[1px] w-full border-[#C5C9CD]">
                          <RadioGroup
                            value={selectedProfile}
                            onChange={(event) =>
                              handleCombinedChange(event, manageSelfProfile)
                            }
                          >
                            <FormControlLabel
                              value={investorId}
                              control={
                                <Radio
                                  sx={{
                                    color: "black",
                                    "&.Mui-checked": { color: "#FF5C39" },
                                  }}
                                />
                              }
                              sx={{
                                borderBottom: 0,
                                borderBottomColor: "#C5C9CD",
                              }}
                              label={
                                <Typography variant="body1">
                                  {username}
                                </Typography>
                              }
                            />
                          </RadioGroup>
                        </div> */}
                        {profileList?.map((account, index) => (
                          <div
                            key={index}
                            className="border-b-[1px] border-[#C5C9CD]"
                          >
                            <RadioGroup
                              value={selectedProfile}
                              onChange={(event) =>
                                handleCombinedChange(event, account)
                              }
                            >
                              <FormControlLabel
                                value={account?.investorId}
                                control={
                                  <Radio
                                    sx={{
                                      color: "black",
                                      "&.Mui-checked": { color: "#FF5C39" },
                                    }}
                                  />
                                }
                                sx={{
                                  borderBottom: 0,
                                  borderBottomColor: "#C5C9CD",
                                }}
                                label={
                                  <Typography variant="body1">
                                    {account?.profileName?.length > 1 ? account?.profileName : account?.firstName} {" "}({account?.userType?.charAt(0)?.toUpperCase() + account?.userType?.slice(1)})
                                  </Typography>
                                }
                              />
                            </RadioGroup>
                          </div>
                        ))}
                        <Typography
                          sx={{
                            cursor: "pointer",
                            color: "#FF5C39",
                            fontSize: "14px",
                            fontWeight: 500,
                            textDecoration: "underline",
                            py: 1,
                          }}
                          onClick={() =>
                            // setExpanded((prev) => ({ ...prev, 0: true }))
                            handleNavigate()
                          }
                        >
                          Add new purchase profile
                        </Typography>
                      </Paper>
                    )}
                    {index === 1 && (
                      <Box>
                        <TextField
                          fullWidth
                          label="Amount"
                          variant="outlined"
                          value={proxyBidPrice}
                          id="proxy-bid-input"
                          autoComplete="off"
                          onChange={handlePriceChange}
                          error={!!reservePriceCheck} // Display error style if there's an error
                          helperText={reservePriceCheck}
                          slotProps={{
                            input: {
                              startAdornment: (
                                <InputAdornment
                                  position="start"
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    color: "black",
                                    backgroundColor: "#F8F8F8",
                                    borderBottomLeftRadius: "4px",
                                    borderTopLeftRadius: "4px",
                                    py: 2.6,
                                    px: 1,
                                  }}
                                >
                                  <AttachMoneyIcon />
                                </InputAdornment>
                              ),
                            },
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              color: "#3B3B3B",
                              fontWeight: 600,
                              fontSize: "16px",
                              height: 45,
                              border: 1,
                              borderRadius: "4px",
                              borderColor: "#C5C9CD",
                              paddingLeft: 0,
                              "&:hover": {
                                // Adjusted the hover selector here
                                borderColor: "rgb(59 130 246 / 0.5)",
                              },
                              "&.Mui-focused": {
                                // Optional: You can also style the focused state if needed
                                borderColor: "rgb(59 130 246)",
                              },
                            },
                            "& .MuiInputLabel-outlined": {
                              color: "#3B3B3B",
                              left: "30px",
                              backgroundColor: "white",
                              fontSize: "16px",
                              fontWeight: 600,
                            },
                            "&MuiOutlinedInput-notchedOutline": {
                              border: "none",
                              borderColor: "transparent",
                              borderWidth: 0
                            }
                          }}
                          inputMode="numeric"
                          inputRef={inputRef}
                        />
                      </Box>
                    )}
                  </Box>
                </StepContent>
              </Step>
            ))}
          </Stepper>
        </Box>
        {/* Proxy Bid Card End*/}
        {/* Bid Protection Enable start */}
        <Box
          mt={2}
          sx={{ backgroundColor: "white", boxShadow: 3, borderRadius: 1, p: 2 }}
        >
          <FormControlLabel
            sx={{
              "& .MuiTypography-root": {
                fontWeight: 500,
                // color:""
              },
            }}
            control={
              <Checkbox
                id="warning-checkbox"
                checked={isBidProtectionEnable}
                onChange={(e) => setIsBidProtectionEnable(e.target.checked)}
                color="warning"
              />
            }
            label={
              <Typography className="text-[#3B3B3B] font-medium text-[14px] leading-[24px]">
                Enable Bid Protection
              </Typography>
            }
          />
          <Typography
            sx={{ fontWeight: 400, fontSize: "14px", lineHeight: "18px" }}
          >
            <span className="font-semibold leading-[18px]">Bid Protection</span>{" "}
            ensures you don't lose an auction to another bidder offering the
            same amount as your proxy bid. If triggered, it will automatically
            increase your bid by up to $1,000, provided you have sufficient
            funds in your account. This additional bid will only be placed if
            you have at least $1,000 available.
          </Typography>
        </Box>
        {/* Bid Protection Enable end */}
        {/*Place Bid Button*/}
        <Box
          display="flex"
          flexDirection={"column"}
          alignItems="center"
          justifyContent="center"
          mt={2}
        >
          <Button
            variant="contained"
            size="large"
            id="place-bid-button"
            sx={{
              px: 2,
              py: 1,
              backgroundColor: completed[1] ? "#FF5C39" : "#9fa4ab",
              textTransform: "none",
              fontSize: 18,
              borderRadius: 2,
            }}
            disabled={loading || !completed[1]}
            onClick={
              PlaceBidText === "Update Bid" ? OnUpdateProxyBid : handleSubmit
            }
          >
            {PlaceBidText}
          </Button>
          {message && (
            <span
              className={"font-normal text-center text-[#28A745] text-base"}
            >
              {message}
            </span>
          )}
          {errors && (
            <span
              className={"font-normal text-center text-[#EF233C] text-base"}
            >
              {getErrorMessage(errors)}
            </span>
          )}
        </Box>
        {/*Place Bid Button*/}
        <Paper
          variant="outlined"
          sx={{
            backgroundColor: "white",
            boxShadow: 3,
            borderRadius: 1,
            p: 2,
            mt: 2,
          }}
        >
          <Typography gutterBottom sx={{ fontWeight: 500, fontSize: "16px" }}>
            How does the proxy bid mechanism work?
          </Typography>
          <Divider />
          <ul class="space-y-2 text-sm text-gray-700 leading-relaxed pt-3">
            <li class="flex items-start">
              <span class="mr-2  font-bold">•</span>
              <span>
                When a proxy bid is placed, the bid amount is locked in the
                user's account. The user must have enough available funds to
                cover the proxy bid amount.
              </span>
            </li>
            <li class="flex items-start">
              <span class="mr-2 font-bold">•</span>
              <span>
                At the end of the proxy bidding period (typically 60 minutes
                before the auction starts), the system follows these steps:
                <ul class="space-y-2 ml-6">
                  <li class="flex items-start">
                    <span class="mr-2  font-bold">-</span>
                    <span>
                      Proxy bids below the estimated opening bid are discarded.
                    </span>
                  </li>
                  <li class="flex items-start">
                    <span class="mr-2  font-bold">-</span>
                    <span>
                      The system identifies the highest proxy bidder based on
                      the bid amounts.
                    </span>
                  </li>
                  <li class="flex items-start">
                    <span class="mr-2  font-bold">-</span>
                    <span>
                      If multiple bidders submit the same highest proxy bid, the
                      bid placed first takes precedence.
                    </span>
                  </li>
                  <li class="flex items-start">
                    <span class="mr-2  font-bold">-</span>
                    <span>
                      All unchosen bids are discarded, and the corresponding
                      funds are released back into the bidders' accounts.
                    </span>
                  </li>
                </ul>
              </span>
            </li>
            <li class="flex items-start">
              <span class="mr-2  font-bold">•</span>
              <span>
                During the live auction, the system automatically places bids on
                behalf of the highest proxy bidder until their proxy bid limit
                is reached.
              </span>
            </li>
            <li class="flex items-start">
              <span class="mr-2  font-bold">•</span>
              <span>
                If bid protection is enabled and the user has an additional
                $1,000 available, the system may place an additional bid if
                necessary.
              </span>
            </li>
            <li class="flex items-start">
              <span class="mr-2 font-bold">•</span>
              <span>
                If the highest proxy bidder is outbid during the live auction,
                the locked funds are released back to their account.
              </span>
            </li>
            <li class="flex items-start">
              <span class="mr-2 font-bold">•</span>
              <span>
                Locked funds are released as follows.
                <ul class="space-y-2 ml-6">
                  <li class="flex items-start">
                    <span class="mr-2  font-bold">-</span>
                    <span>
                      If user wins the auction, any additional funds over the final highest bid will be released back to user's account.
                    </span>
                  </li>
                  <li class="flex items-start">
                    <span class="mr-2  font-bold">-</span>
                    <span>
                      If user is outbid, funds are released after the next bidding round (This is to ensure that if the auctioneer retracts the current highest bid, the user's bid can be placed again).
                    </span>
                  </li>
                </ul>
              </span>

            </li>
            <li class="flex items-start">
              <span class="mr-2 font-bold">•</span>
              <span>
                If an auctioneer chooses to redo an auction, the system will re-lock funds corresponding to the user's original proxy bid (subject to fund availability). Once the auction restarts, system will place proxy bids on behalf of the user.
              </span>
            </li>
          </ul>
        </Paper>
      </List>
    </Box>
  );

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      // onClose={(event) => toggleSidebar(false, event)}
      sx={{ zIndex: 1300, width: "650px" }}
    >
      {list("right")}
    </Drawer>
  );
}
